import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Button from '../../components/Button';
import List from '../../components/List';
import Icon from '../../components/Icon';
import REPVISITS_LOCATION_TYPE from '../../utils/repvisits-location-types';

import './styles.css';

class AvailabilitySlots extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.shape({
      repVisitsSchedule: PropTypes.arrayOf(PropTypes.shape({
        appointments: PropTypes.arrayOf(PropTypes.shape({
          startISOTime: PropTypes.string,
          endISOTime: PropTypes.string,
        })),
      })),
    }),
    appointments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      startTime: PropTypes.string,
      startISOTime: PropTypes.string,
      endTime: PropTypes.string,
      endISOTime: PropTypes.string,
      status: PropTypes.string,
      visitLocationType: PropTypes.string,
    })).isRequired,
    webInstructions: PropTypes.string,
    dayId: PropTypes.string,
    onClick: PropTypes.func,
  };

  matchingAppointment = (appointment, scheduledAppointment) => (
    appointment.id === scheduledAppointment.appointmentId
  );

  isScheduledAppointment = (appointment, scheduledAppointments) => (
    scheduledAppointments &&
    scheduledAppointments.find((scheduledAppointment) => this.matchingAppointment(appointment, scheduledAppointment))
  );

  isOpenAppointment = (appointment, scheduledAppointments) => (
    (appointment.status === 'OPEN' || appointment.status === 'PARTIALLY_OPEN') &&
    !this.isScheduledAppointment(appointment, scheduledAppointments)
  );

  getButtonStyle = (visitLocationType) => {
    if (visitLocationType === REPVISITS_LOCATION_TYPE.VIRTUAL) return 'availability-button-virtual';
    if (visitLocationType === REPVISITS_LOCATION_TYPE.EITHER) return 'availability-button-either';
    return 'availability-button-in-person';
  }

  getButtonIcon = (visitLocationType) => {
    if (visitLocationType === REPVISITS_LOCATION_TYPE.VIRTUAL) return <Icon name="tv" />;
    if (visitLocationType === REPVISITS_LOCATION_TYPE.EITHER) {
      return (
        <Icon.Group>
          <Icon name="user" />
          <Icon corner="top right" name="pencil" />
        </Icon.Group>
      );
    }
    return <Icon size="large" name="male" />;
  }

  renderVirtualButton = (dayId, row) => (
    <Button
      icon
      title={row.startTime}
      size="mini"
      onClick={() => this.props.onClick(dayId, row.id, this.props.webInstructions)}
      styleName={this.getButtonStyle(row.visitLocationType)}
    >
      {this.getButtonIcon(row.visitLocationType)}
      <p styleName="availability-button-text">{row.startTime}</p>
    </Button>
  );

  render() {
    const { viewer, appointments, dayId } = this.props;
    const scheduledAppointments = get(viewer, 'repVisitsSchedule[0].appointments');
    const openAppointments = appointments.filter((appointmentSlot) => this.isOpenAppointment(appointmentSlot, scheduledAppointments));
    return (
      <List>
        {openAppointments.map((row) => (
          <List.Item key={row.id}>
            {this.renderVirtualButton(dayId, row)}
          </List.Item>
        ))}
      </List>
    );
  }
}

export default AvailabilitySlots;
